export default __webpack_public_path__ + "static/media/logo_full_white.d836c3e1.svg";